import "./CopyToClipboardButton.scss";

import CopyToClipboardButton from "./CopyToClipboardButton";

export default CopyToClipboardButton;